import React from 'react'
import styles from "../css/ErrorPage.module.css"
import LogoItem from '../../Logo/LogoItem'

const ErrorPage = ({ errorStatus, errorMessage, errorDesc, handleRetry, page = "notes"}) => {

    return (
        <div className = {`${styles.wrapper} ${styles.crash}`} data-testid = "crash-page">
            {page === "demo" && <header>
                <div className = {styles.headerContent}>
                    <LogoItem/>
                </div>
            </header>}
            <div className = {styles.content}>
                <div className = {styles.errorBody}>
                    <div className={styles.errorLeft}>
                        <div className={styles.errorEyebrow}>Error {errorStatus}</div>
                        <div className={styles.errorCode}><em>{errorStatus}</em></div>
                        <div className={styles.errorTitle}>{errorMessage}</div>
                        <div className={styles.errorDesc}>
                            {errorDesc}
                        </div>
                        {errorStatus === 500 && <div className={styles.errorActions}>
                            <button className={styles.btnPrimary} onClick = {()=>handleRetry()}>↻ &nbsp;Try again</button>
                        </div>}
                    </div>
                    <div className={styles.errorRight}>
                        <div className={styles.illus404}>
                            <div className={styles.illusBgText}>{errorStatus}</div>
                        </div>
                        <div className = {styles.imageArea}>
                            <img
                                src = "/assets/500Error.png"
                                alt="500 ERROR"
                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <footer>
                <p>© {new Date().getFullYear} NotePro. All rights reserved.</p>
            </footer>
        </div>
    )
}

export default ErrorPage